
<template>
    <div class="header-bar-pathfinder">
        <!-----------------  responsive menu -------------------->
        <v-navigation-drawer absolute v-model="sideNav"
                             class="hidden-sm-and-up mobile-menu border-bottom elevation-bg-color"
                             width="340">
            <v-list class="pf-menu-mobile">
                <v-divider></v-divider>
                <SettingsList
                    :is-p-f-i="true"
                    @closeSideNav="closeSideNav"
                    :side-nav="sideNav"></SettingsList>


            </v-list>
            <v-divider></v-divider>

            <!-- Show "Quit" button when the assessment wasn't started with a voucher. -->
            <!-- So if the assessment has been started with a voucher (by using an url like "/voucher?v=..."), the "Quit" button should only be displayed if this callbackUrlCancel is present. -->
            <v-btn v-if="getVoucherData === null && !getAppPropertyStudyAccess"
                   @click="quitAssessment"
                   id="menuBtnQuitAssessmentSmDisplay"
                   class="menu-settings quit"
                   flat
                   :ripple="false"
                   color="primary"
            >
                {{text('api.button.header.bar.quit')}}
            </v-btn>
            <v-btn v-else-if="getVoucherData !== null && typeof getVoucherData.callbackUrlCancel !== 'undefined' && getVoucherData.callbackUrlCancel !== null"
                   @click="redirectToExternalUrl(getVoucherData.callbackUrlCancel)"
                   id="menuBtnQuitToExtUrlSmDisplay"
                   class="menu-settings quit"
                   flat
                   :ripple="false"
                   color="primary">
                {{text('api.button.header.bar.quit')}}
            </v-btn>
        </v-navigation-drawer>

        <!----------------- general menu ---------------------->
        <v-toolbar  fixed class="header header-pathfinder">
            <v-spacer class="hidden-sm-and-up"></v-spacer>
            <v-toolbar-side-icon
                v-if="!sideNav"
                @click.native.stop="sideNav = !sideNav"
                class="hidden-sm-and-up mobile-menu-btn"
            >

            </v-toolbar-side-icon>
            <v-toolbar-side-icon
                v-if="sideNav"
                @click.native.stop="sideNav = !sideNav"
                class="hidden-sm-and-up mobile-menu-btn">
                <close-icon :svg-fill-class="'svg-secondary-color'"/>
            </v-toolbar-side-icon>
            <v-toolbar-title v-if="logo">
                <img  v-bind:src="logo" alt="smass logo"  class="logo">
                <ce-icon v-if="getAppPropertyValue('GUI_THEME_LOGO_CE') === 'true'" class="ce-logo-header"/>
            </v-toolbar-title>

            <v-toolbar-items class="pages hidden-xs-only">


            </v-toolbar-items>

            <v-spacer class="hidden-xs"></v-spacer>


            <v-toolbar-items class="hidden-xs-only language-dropdown-container no-margin-right">

                <!-- Show "Quit" button when the assessment wasn't started with a voucher. -->
                <!-- So if the assessment has been started with a voucher (by using an url like "/voucher?v=..."), the "Quit" button should only be displayed if this callbackUrlCancel is present. -->
                <div v-if="!getAppPropertyStudyAccess" class="header-bar-medical-device-item-wrapper">
                    <v-btn v-if="getVoucherData === null"
                           @click="quitAssessment"
                           id="menuBtnQuitAssessmentLgDisplay"
                           class="menu-settings quit hidden-xs-only"
                           flat
                           :ripple="false"
                           color="primary">
                        {{text('api.button.header.bar.quit')}}
                    </v-btn>
                    <v-btn v-else-if="getVoucherData !== null && typeof getVoucherData.callbackUrlCancel !== 'undefined' && getVoucherData.callbackUrlCancel !== null"
                           @click="redirectToExternalUrl(getVoucherData.callbackUrlCancel)"
                           id="menuBtnQuitToExtUrlLgDisplay"
                           class="menu-settings quit hidden-xs-only"
                           flat
                           :ripple="false"
                           color="primary"
                    >
                        {{text('api.button.header.bar.quit')}}
                    </v-btn>
                </div>

                <div
                    @click="showMedicalDeviceInfoPopup"
                    id="menuIconShowMedicalDeviceInfoLgDisplay"
                    class="hidden-xs show-info-popup-icon header-bar-medical-device-item-wrapper"
                >
                    <svg-button

                        class="hidden-xs"
                        :button-width="36"
                        :button-height="36"
                    >
                        <medical-device-info-icon
                            :height="36" :width="36"/>
                    </svg-button>
                </div>
                <SettingsMenu
                    :is-p-f-i="true"
                    class="hidden-xs-only"></SettingsMenu>


            </v-toolbar-items>

            <v-toolbar-items class="hidden-sm-and-up header-bar-medical-device-item-wrapper">

                <svg-button
                    @click.native="showMedicalDeviceInfoPopup"
                    id="menuIconShowMedicalDeviceInfoSmDisplay"
                    style="padding: 0;"
                    :button-height="36"
                    :button-width="36"
                >
                    <medical-device-info-icon :width="36" :height="36"/>
                </svg-button>
            </v-toolbar-items>
        </v-toolbar>
        <!-- INFO POPUP -->
        <info-popup></info-popup>
    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import LoginPage from '../../../common/components/login/LoginPage';
import axios from 'axios/dist/axios';
import Vue from "vue";
import InfoPopup from '../../../common/components/shared/InfoPopup';
import CeIcon from "../../../common/components/svg/info-popup/ceIcon";
import MedicalDeviceInfoIcon from "../../../common/components/svg/shared/medicalDeviceInfoIcon";
import SettingsIcon from "../../../common/components/svg/shared/settingsIcon";
import SvgButton from "../../../common/components/shared/SvgButton";
import CloseIcon from "../../../common/components/svg/shared/closeIcon";
import LightThemeIcon from "../../../common/components/svg/shared/lightThemeIcon";
import DarkThemeIcon from "../../../common/components/svg/shared/darkThemeIcon";
import HighContrastLightIcon from "../../../common/components/svg/shared/highContrastLightIcon";
import HighContrastDarkIcon from "../../../common/components/svg/shared/highContrastDarkIcon";
import BaseSwitch from "../../../common/components/shared/BaseSwitch";
import SettingsMenu from "../../../common/components/shared/SettingsMenu";
import SettingsList from "../../../common/components/shared/SettingsList";

export default {
        name: 'HeaderBarMedicalDevice',
        components: {
            SettingsList,
            SettingsMenu,
            BaseSwitch,
            HighContrastDarkIcon,
            HighContrastLightIcon,
            DarkThemeIcon,
            LightThemeIcon,
            CloseIcon,
            SvgButton,
            SettingsIcon,
            MedicalDeviceInfoIcon,
            CeIcon,
            LoginPage,
            InfoPopup
        },
        data () {
            return {
                sideNav: false,
                account: false,
                currentItem: 'home', // @TODO Do we need this?
                settings: false,
                radioButtonPlugin: Vue.RadioButton.RadioButtonSvg,
                menuIconPlugin: Vue.MenuIcon.menuIconSvg
            }
        },

        computed: {
            ...mapGetters({
                isAdmin: 'UserStore/getIsAdmin',
                getFullName: 'UserStore/getFullName',
                logo: 'TranslationStore/getLogo',
                isKSB: 'TranslationStore/getAppTypeName',
                getAssessmentStarted: 'ChatBotStore/getAssessmentStarted',
                getMustShowMedicalDeviceInfoPopup: 'MedicalDeviceInfoStore/getMustShowMedicalDeviceInfoPopup',
                getVoucherData: 'TranslationStore/getVoucherData',
                getVoucherCallbackData: 'TranslationStore/getVoucherCallbackData',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getAppPropertyStudyAccess: 'TranslationStore/getAppPropertyStudyAccess'
            }),


            mustShowFullQuestion: {
                get () {
                    return this.$store.getters['ProductListStore/getMustShowFullQuestion'];
                },
                set (newVal) {
                    this.$store.commit('ProductListStore/setMustShowFullQuestion', newVal);
                },
            },
        },

        created() {
            window.addEventListener("resize", this.resizeWindow);
        },

        mounted() {
            let menuIcon = document.querySelector('.toolbar__side-icon.btn.btn--icon i.icon');
            menuIcon.innerHTML = this.menuIconPlugin();
        },

        destroyed() {
            window.removeEventListener("resize", this.resizeWindow);
        },

        methods: {
            logOut() {
                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                    this.$router.push('/');
                });
            },
            closeSideNav() {

                if (this.sideNav) {
                    this.sideNav = false;
                }
            },

            showMedicalDeviceInfoPopup(){
                this.$store.dispatch("MedicalDeviceInfoStore/showMedicalDeviceInfoPopup")
                .then((res)=>{
                    this.PfChatbotPlugin.hideScroll();
                })
            },


            goToHomePage() {
                this.$router.push({name: 'PF_ChatBotPage'}).then(() => { // Go to Chatbot's home page (product list).
                    sessionStorage.removeItem("crtChatbotSection");
                    window.location.reload();
                });
            },

            quitAssessment() {

                axios.post(process.env.API_BASE_URL + '/assessment/cancelAssessment').then((response) => {
                    if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                        this.goToHomePage();
                    }
                    else {
                        alert("Unexpected error.");
                        console.error("Unexpected error! Couldn't cancel the assessment.");
                    }
                });
            },

            goToAssessmentListPage() {
                this.$router.push('/assessment-list');
            },

            goToTestsPage() {
                this.$store.commit('TestStore/setGetTreeData', false);
                this.$store.dispatch("ProductListStore/loadProductListPageData").then(() => {
                    this.$router.push('/tests');
                });
            },

            redirectToExternalUrl(url) {

                axios.post(process.env.API_BASE_URL + '/assessment/cancelAssessment').then((response) => {
                    if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                        window.location.href = url;
                    }
                    else {
                        alert("Unexpected error.");
                        console.error("Unexpected error! Couldn't redirect.");
                    }
                });
            },


            resizeWindow(){
                if(this.$vuetify.breakpoint.xsOnly) {
                    this.sideNav = false;
                }
            }
        },
        watch: {
            sideNav(newVal, oldValue) {
                if(!newVal) {
                    this.$nextTick(() => {
                        let menuIcon = document.querySelector('.toolbar__side-icon.btn.btn--icon i.icon');
                        if (menuIcon) {
                            menuIcon.innerHTML = this.menuIconPlugin();
                        }

                    })

                }
            }
        },


    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>


    .toolbar.toolbar--fixed.header {
        background-color: $color-elevation-background;
        padding: 0 20px;
        overflow: hidden;
        box-shadow: none;
        border-bottom: 1px solid $color-block-border;

        .toolbar__content {

            .user {
                width: 18px;
                height: 18px;
                margin-right: 2px;
            }
        }

    }

    .btn-menu {
        max-width: 100%;

        .settings, .user {
            // height: 40px;
            //height: 32px;
            //width: 32px;
            &:first-of-type {
                // margin-left: 5px !important;

                span {
                    position: relative;
                    top: 2px;
                }
            }
        }
    }



    .menu__content {

        .list__tile__action {
            min-width: 100%;

            .input-group.input-group--selection-controls {
                min-width: 100%;
            }
        }
    }

    .settings {
        font-weight: $font-size-medium;

    }

    .btn-logout-icon:hover {
        cursor: pointer;
    }

    .user-account {
        color: $color-headings-text;
    }


    .user-logged img, .account-settings img {
        width: 22px;
    }

    .account-settings img.account{
        position: relative;
        top: 5px;
        margin-right: 18px;

    }

    .account-settings img.logout {
        margin-right: 18px;
    }

    .user-logged .list__tile__title:first-of-type {
        height:  44px !important;

        img {
            position: relative;
            top: 10px;
            width: 32px;
            margin-right: 7px;
        }
    }



    .toolbar__items .start-assesment-btn {
        margin-right: 20px;
        position: relative;
        top: 0;
        color: $color-brand-primary;
        border: 1px solid #d3d5d9;
        padding: 7px 20px;
        height: 38px;
        border-radius: 27px;
        // SMASSDEV - 1119
        font-size: $font-size-small;
        // word-spacing: $word-spacing-small;
        // line-height: $line-height-small;
        // letter-spacing: $letter-spacing-small;
        text-transform: uppercase;
    }

    @supports not (-ms-high-contrast: none) {
        @media only screen and (max-width: 960px) and (min-width: 600px) {
            .toolbar__items.language-dropdown-container {
                /*position: absolute;*/
                /*right: 15px;*/
            }

            .toolbar__items .start-assesment-btn {
                margin-right: 0;
                // SMASSDEV - 1119
                font-size: $font-size-extra-small;
                // word-spacing: $word-spacing-extra-small;
                // line-height: $line-height-extra-small;
                // letter-spacing: $letter-spacing-extra-small;
                position: relative;
                left: 15px;
            }
        }

        @media only screen and (min-width: 960px) {

            .toolbar__items .start-assesment-btn {
                margin-right: 20px;
                // SMASSDEV - 1119
                font-size: $font-size-small;
                // word-spacing: $word-spacing-small;
                // line-height: $line-height-small;
                // letter-spacing: $letter-spacing-small;
            }
        }
    }


    @media all and (-ms-high-contrast:none) {
        *::-ms-backdrop, .language-dropdown-container.toolbar__items {
            /*position: fixed !important;*/
            /*right: 0;*/
            /*top: 0;*/
        }

        *::-ms-backdrop, .language-dropdown-container.toolbar__items .start-assesment-btn {
            margin-right: 0;
            padding: 7px;
        }

    } /* IE11 */



    .new-assessment-btn-header {
        font-weight: $font-weight-regular;
        text-transform: none;
        border-radius: 20px;
        padding: 0 15px;
        border-color: $color-element-outline;
    }
    @media only screen and (min-width: 960px) {
        .header-pathfinder {
            padding-right: 32px !important;
            padding-left: 32px !important;
        }
    }

    @media only screen and (min-width: 600px) and (max-width:959px){
        .header-pathfinder {
            padding-right: 20px !important;
            padding-left: 20px !important;
        }
    }

    @media only screen and (max-width: 599px) {
        .header-pathfinder {
            padding-right: 16px !important;
            padding-left: 16px !important;

            .mobile-menu-btn, .toolbar__side-icon {
                position: absolute !important;
                left: 0;
                bottom: 3px;
            }
        }
    }

    .navigation-drawer {
        margin-top: 60px !important;
        box-shadow: none !important;
    }

    .legal-btn-mobile.print-legal {
        border-bottom: none !important;
    }

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/shared/HeaderBarMedicalDevice.vue